// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"9d2545c7","99":"47bc6585","288":"0dc66d8d"}[chunkId] + ".chunk.js";
};